export const Module = 'module'
